@if (href) {
<a
  [attr.href]="href"
  [attr.class]="linkClassList"
  [attr.target]="newTab ? '_blank' : undefined"
  (click)="linkClick.emit()"
>
  <ng-container *ngTemplateOutlet="label"></ng-container>
</a>
} @else {
<a
  [routerLink]="routerLink"
  [queryParams]="queryParams"
  [attr.class]="linkClassList"
  [attr.target]="newTab ? '_blank' : undefined"
  (click)="linkClick.emit()"
>
  <ng-container *ngTemplateOutlet="label"></ng-container>
</a>
}

<ng-template #label>
  <ng-content></ng-content>
</ng-template>
